import {
  getDeleteAgentDirectChannelDefaultErrorMessage,
  getIsDeletingDirectChannelLoading,
} from 'gcs-common/slices/administration/administrationChannels/administrationChannelsSelectors';
import { resetDeleteDirectChannelDefaultErrorMessage } from 'gcs-common/slices/administration/administrationChannels/administrationChannelsSlice';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showFailureNotification } from '../../../../slices/notifications/ShowNotificationThunk';
import Button from '../../../Button/Button';
import styles from './styles.module.scss';

const DirectChannelDelete = ({ message, onCancel, handleDelete }) => {
  const isDeleting = useSelector(getIsDeletingDirectChannelLoading);
  const dispatch = useDispatch();
  const defaultErrorMessage = useSelector(getDeleteAgentDirectChannelDefaultErrorMessage);

  useEffect(() => {
    if (defaultErrorMessage) {
      dispatch(showFailureNotification(defaultErrorMessage, dispatch(resetDeleteDirectChannelDefaultErrorMessage())));
    }
  }, [defaultErrorMessage, dispatch]);

  useEffect(() => {
    dispatch(resetDeleteDirectChannelDefaultErrorMessage());
  }, [dispatch]);

  return (
    <div className={styles.column}>
      {message}
      <div className={styles.buttonRow}>
        <Button className={styles.modalButtonSecondary} type="button" disabled={isDeleting} onClick={onCancel}>
          Abbrechen
        </Button>
        <Button className={styles.modalButton} type="button" onClick={handleDelete} disabled={isDeleting}>
          Löschen
        </Button>
      </div>
    </div>
  );
};

DirectChannelDelete.propTypes = {
  message: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

export default DirectChannelDelete;
